import {NavigationPathKey, TranslationKey} from '@enums'
import {SearchTableWrapper} from '@wrappers'

import React from 'react'

import {UIKit} from '@components'

import {useContractTypeSearchModel} from './contract-type-search-model'

/**
 * Contract Type Search page
 */
export function ContractTypeSearchPage() {
  const {rows, columns, t, showCreateButton, navigate} = useContractTypeSearchModel()

  return (
    <SearchTableWrapper>
      <UIKit.Table
        {...(showCreateButton && {
          buttonProps: {
            buttonText: t(TranslationKey['Add new contract type']),
            onClick: () => navigate(NavigationPathKey.CONTRACT_TYPE_CREATION),
          },
        })}
        columns={columns}
        rows={rows}
        title={t(TranslationKey['List of contract types'])}
      />
    </SearchTableWrapper>
  )
}
